<template>
  <div :class="$style['select-task-dialog']">
    <el-dialog width="70%" :visible="dialogVisible" title="" @close="cancel">
      <ptProductionTaskList :hideTitle="true" :showSearch="true" :hasComplete="true" selectType="radio" @updateSelectData="updateSelectData" :billId="billId" :onlyNoBill="onlyNoBill" :noDownLoad="noDownLoad" :noExportOption="noExportOption"></ptProductionTaskList>
      <div class="button-div">
        <el-button type="primary" @click="submit">选择</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ptProductionTaskList from 'cps/production-task/pt-production-task-list/index'
import { customerTableLabels } from 'cps/customer-manage/pt-customer-manage/options.js'
export default {
  name: 'default-package-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: '选择委托方'
    },
    pageSize: {
      type: Number,
      default: 8
    },
    // 传进的id // 用于回显
    clientId: {
      type: String,
      default: ''
    },
    // 传进的商品对象
    data: {
      type: Object,
      default: () => {}
    },
    billId: String,
    onlyNoBill: Boolean,
    // 列表没有下载操作
    noDownLoad: Boolean,
    noExportOption: Boolean
  },
  components: { ptProductionTaskList },
  computed: {
    tableLabels () {
      return customerTableLabels
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableData: [],
      selectId: this.clientId ? this.clientId : '',
      page: 0,
      select_row: null,
      isContractFunction: null
    }
  },
  watch: {
  },
  methods: {
    updateSelectData (data) {
      this.select_row = data
    },
    submit () {
      // if(this.selectedKeys && !this.select_row){
      //   this.cancel()
      //   return
      // }
      console.log('---1')
      this.$emit('selectData', this.select_row)
    },
    cancel () {
      this.$emit('close')
    }
  }
}
</script>
<style module lang="less">
@import "~less/var";
.select-task-dialog{
    :global
    .el-pagination{
        justify-content: flex-start!important;
    }
     :global
    .el-radio__label{
        display: none;
    }
    :global{
      .el-radio__inner{
          border:1px solid #409eff;
          border-radius:50%
      }
      .el-input__inner{
        width:auto !important;
      }
    }

}
</style>
